module.exports = __webpack_public_path__ + "img/4.430689c3.png";